import {today} from "../../lib/utilities";

export default {
    date: true,
    dateMax: today(),
    dateMin:'2012-12-1',
    datePattern: ['m', 'd', 'Y']
}